// extracted by mini-css-extract-plugin
export default {"arrowDisabled":"zH5dPThWNtLb1EWXUJBj","rotate":"lADDx0YSo9oUAbFYPZGQ"};